var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGuidoWaiting(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 637.99 743.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_14",
    "data-name": "Camada 14"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M229.85,121.72l-1.18,21.43-4.37,80.11L193,238.81s4.05-85.53,4.05-100a8,8,0,0,1,1.07-4l0,0h0c3.46-6.08,14.9-10.35,31.67-13",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.05,505.64c-79,47.41-156.78,97.12-22.78,136s348,43.22,382.57,23.77,64.84-56.19,45.39-105.91,30.25-108.07-77.81-129.68S198,458.24,119.05,505.64",
    style: {
      fill: "#b7f9e7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M485,483.5l0,.24c-2.17,16-5.45,32.22-12.37,46.85A79.5,79.5,0,0,1,468.7,538c-9.07,15-21.46,23.84-37.55,28.94-2.5.8-5.09,1.52-7.76,2.12q-5.81,1.37-12.19,2.27a.93.93,0,0,0-.26,0c-17.63,2.45-38.58,2.58-63.21,2.38-21.6-.17-46-.59-73.47.1-44.81,1.13-71.58-2.9-87.12-10.46C154.46,547.4,171.28,515.8,174,483.62c2.12-25.4-2.25-66.54-6-105.77-.23-2.39-.46-4.78-.68-7.14-1-10.93-2-21.63-2.67-31.7q-.27-4-.5-7.84v0c-.91-15.48-1.09-29.13.09-39.35a161.27,161.27,0,0,1,2.2-20.15l0-.16c0-.12,0-.3.08-.53a161.29,161.29,0,0,1,127-129.59c1.78-.34,3.6-.65,5.4-1H299c.2,0,.41-.06.62-.1l.06,0c5-.89,21.43-1.81,24.67-1.34,0,0-7.47-11.13-23.65-16-4.59-1.37-7.55-3.39-9.37-5.58l-.12-.15c-4.62-5.72-1-14.28,6.29-15.38a18.34,18.34,0,0,1,5.86.1c10.12,1.9,19.94,8.75,28,16.14,3.17,2.93,6.07,5.92,8.61,8.77,1.17,1.3,2.27,2.58,3.27,3.79,4.25,5.08,6.95,9,7.39,9.6-.87-1.49-1.69-4.59-5.06-8.92a19.26,19.26,0,0,1-1.76-2.65c-4.47-8.26,2.65-12.77,8.58-11.3,11.53,2.84,17.95,16.84,20.54,24.12l.08.2c.89,2.52,1.31,4.16,1.31,4.19a160.31,160.31,0,0,1,67,41.32l.06.05a147.36,147.36,0,0,1,16.2,20.2c30.46,45.8,26.07,152,27.52,200.32.85,28.64.47,70.68,0,75.71",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.7,351.65l7.68,3.35a10.32,10.32,0,0,1-4.93-1.28A13.3,13.3,0,0,1,315.7,351.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.55,272.4a128.93,128.93,0,0,1-3.29,16.09c-.11.46-.23.92-.36,1.37q-.9,3.18-1.9,6.28a150.83,150.83,0,0,1-7.81,19c-1.23,2.47-2.49,4.87-3.81,7.18h0c-.73,1.29-1.47,2.54-2.23,3.77-.25.42-.51.83-.76,1.24-1.07,1.7-2.16,3.34-3.25,4.94l-.15.21c-.65.9-1.28,1.8-1.92,2.66-.35.47-.7.93-1.05,1.37s-.7.91-1,1.34c-1.39,1.75-2.81,3.41-4.24,4.94-.35.37-.7.75-1.06,1.12L341.61,345a53.6,53.6,0,0,1-4.25,3.81l-.52.41c-.23.18-.45.36-.68.52s-.74.55-1.12.81l-1.07.74c-.44.27-.87.54-1.3.78s-.62.36-.93.53-.66.35-1,.51-.86.4-1.29.58a6.37,6.37,0,0,1-.79.3c-.19.08-.39.14-.58.2a8.39,8.39,0,0,1-.85.27l-.75.19a9.4,9.4,0,0,1-1,.19c-.22,0-.43.06-.65.08a11.8,11.8,0,0,1-1.44.08l-7.68-3.35c-4-3.88-7.47-11.42-8.74-24.59-.28-3.05-.47-6.38-.51-10.06-.06-4,.05-8.3.36-13.05,0-.1,0-.2,0-.29.36-5.21.91-10.89,1.73-17.09a120.38,120.38,0,0,1,2.79-14.49c9.35-36.26,33.21-56.71,46.7-53.49,12.81,3.06,21.61,24,17.51,53.81",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.63,294.3a114.7,114.7,0,0,0-2.09-15.49c-.1-.5-.21-1-.32-1.47-7-31.63-26.62-50.34-38.71-48.31-13.1,2.23-23.09,24.46-18.43,56.62.36,2.52.8,5.11,1.35,7.76a136,136,0,0,0,7.19,23.44c.72,1.71,1.43,3.37,2.2,5,5.21,11.38,11.6,20.95,18,27h0c6.3,6,12.55,8.65,17.62,6.25,5.68-2.7,11.48-11.57,13.19-32.25q.22-2.78.35-5.83c0-.88.07-1.77.1-2.68,0-.48,0-.95,0-1.43s0-1.08,0-1.64c0-1,0-2,0-3v-1.07c0-4-.2-8.32-.48-12.93",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.16,326.12c-1.31,2.16-2.65,4.21-4,6.18C353.5,330.33,354.85,328.26,356.16,326.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.46,194.46l8.65-31.8s42.23,7.59,47.05,52.73C390.16,215.39,371.15,194.43,334.46,194.46Z",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.39,571.3c-15.46,2.16-33.47,2.52-54.25,2.45-23.74-.09-51.12-.75-82.44,0-33.65.84-57.11-1.23-73.31-5.51a75.44,75.44,0,0,1-13.81-5c-3.47-13.3-6.33-28.18-5-38,2.78-20.4,9.73-63.49,9.73-78.32s14.72-28.95,30.87-30.95c56.41-7,143.48-3.48,165.41,4.53,29.19,10.65,45.83,93.39,22.79,150.72",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.2,545.75H266.47c-1.2,3.61-2.39,7-3.68,10-3.21,7.65-7.07,13.66-13.23,18.08q5.22.12,10.87.12,6.81,0,14.27-.18c9.71-.25,19-.36,28-.39-4.89-4-8-9.31-10.6-16.1q-1-2.47-1.87-5.22c-.67-2-1.34-4.12-2-6.34",
    style: {
      fill: "#bcbcbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.35,103.51a9.49,9.49,0,0,0-2.14,13.75l.08.1-.09-.12a9.49,9.49,0,0,1,2.15-13.73",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.1,101.67a18.36,18.36,0,0,0-2.59.19,9.64,9.64,0,0,0-4.16,1.65,9.49,9.49,0,0,0-2.15,13.73l.09.12,0,0c-1.31-5,5.89-8.16,15.07-8.16,8.29,0,18.19,2.6,24.93,8.88h0c-8-7.39-17.85-14.24-28-16.13a18,18,0,0,0-3.25-.3",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.31,139.94c.21.53.4,1,.57,1.52v0c-.17-.49-.37-1-.58-1.56m-29.8-14.63a12.15,12.15,0,0,0,1.26,3.39h0a12,12,0,0,1-1.26-3.38m7.57-8.2a9.32,9.32,0,0,0-3,.49,9.32,9.32,0,0,1,3-.49,9.22,9.22,0,0,1,2.27.28l.63.17-.63-.17a9.22,9.22,0,0,0-2.27-.28",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.08,117.11a9.32,9.32,0,0,0-3,.49,6.52,6.52,0,0,0-4.58,7.71,12,12,0,0,0,1.26,3.38h0c0-.06,1.9-4.56,6.41-4.56a9.29,9.29,0,0,1,4.32,1.21c7.44,3.87,16.61,12,18.38,16.11-.17-.48-.36-1-.57-1.52-2.85-7.39-9-19.41-19.33-22.38l-.63-.17a9.22,9.22,0,0,0-2.27-.28",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.61,140.29l-.6.11h.08l.52-.1m0,0h0l-.14,0,.14,0h0m21.77-1.5c-2.74,0-6.72.16-10.61.41,3.86-.24,7.8-.4,10.53-.4a23.92,23.92,0,0,1,3,.13v0a25.26,25.26,0,0,0-2.92-.12",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.09,140.39h0m22.24-1.59c-2.73,0-6.67.16-10.53.4-4.52.29-8.92.69-11.13,1.08h-.06l-.14,0-.15.05a48.23,48.23,0,0,1,5.07-.26,69.45,69.45,0,0,1,22.91,4.23l-3-5.43h0v0a23.92,23.92,0,0,0-3-.13",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.07,523c-1.74-6-1.85-10.77-.81-14.31.23,3.9.51,8.92.81,14.31",
    style: {
      fill: "#bcbcbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59,376.88h0c.12,11.71.19,22.24.45,30.91.31,10.46.45,22.71.49,34.29h0c0-11.58-.18-23.83-.48-34.3-.26-8.67-.34-19.2-.46-30.9m-43.26-189.6h0a147.1,147.1,0,0,1,9.94,11.5,149.4,149.4,0,0,0-9.94-11.51",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420,569.76c-1.41.29-2.85.56-4.31.81,1.46-.25,2.9-.52,4.31-.81m11.46-3-.28.09-.14.05.15-.05.27-.09m53.05-79.4c-2.18,14.83-5.47,29.68-11.86,43.19-.59,1.26-1.2,2.47-1.82,3.66.63-1.18,1.23-2.4,1.82-3.66,6.38-13.52,9.69-28.35,11.86-43.19m.93-17.77c-.09,7.19-.23,12.31-.38,13.87l0,.14,0-.14c.15-1.56.29-6.68.38-13.87m.12-27.55c0,.92,0,1.84,0,2.76,0-.92,0-1.84,0-2.76h0",
    style: {
      fill: "#76a195"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.59,376.88a46.29,46.29,0,0,1-8.37.76,44.15,44.15,0,0,1-7.07-.56c-.09.34-.15.52-.15.52h0c7.73,2.91,14.4,10.83,14.39,24.21a47.47,47.47,0,0,1-.95,9.17c-4.65,23.78-2.38,57.54-17.43,82.09a113.76,113.76,0,0,1-3,13.36c-2.85,9.47-12.47,16.27-21.34,16.27a14.7,14.7,0,0,1-9.73-3.47q-4.25,1.41-9,2.49c-1,17.08-4.32,34.21-10.47,49.53,1.44-.21,2.86-.44,4.25-.68s2.9-.52,4.31-.81c1.15-.23,2.29-.49,3.42-.75,2.62-.58,5.17-1.3,7.62-2.07l.14-.05.28-.09c16-5.12,28.25-13.89,37.27-28.85.72-1.19,1.42-2.42,2.1-3.7s1.23-2.4,1.82-3.66c6.39-13.51,9.68-28.36,11.86-43.19.18-1.22.35-2.45.51-3.67l0-.09,0-.14c.15-1.56.29-6.68.38-13.87.09-6.83.14-15.53.13-24.79,0-.92,0-1.84,0-2.76,0-11.58-.18-23.83-.49-34.29-.26-8.67-.33-19.2-.45-30.91M441.33,187.29c.87,1.17,13.9,19.09,23.35,63.32a42.27,42.27,0,0,1,7.62-.68c.61,0,1.23,0,1.86,0-3.88-16.61-9.23-31.34-16.65-42.49-2-3-4.06-5.88-6.24-8.69a147.1,147.1,0,0,0-9.94-11.5",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.88,521.72l-1,.21c-1.15,4.53-2.8,9.76-4.88,15.61a146.67,146.67,0,0,1-6.31,15.76C406,560.85,401,567.74,393,573c6.32-.38,12.29-.93,17.92-1.71a1.14,1.14,0,0,1,.26,0l.2,0c6.15-15.32,9.47-32.45,10.47-49.53",
    style: {
      fill: "#a5a5a5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.18,240.33A160.43,160.43,0,0,0,166.51,271c0,.22-.06.39-.08.52v0c0-.12,0-.3.08-.53a159.79,159.79,0,0,1,8.66-30.63m124.43-100h0",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.32,140.37a1.27,1.27,0,0,0-.28,0h-.1c-1.8.32-3.62.62-5.4,1a161.48,161.48,0,0,0-118.36,99A159.79,159.79,0,0,0,166.52,271c0,.23-.07.41-.08.53v.11c.7-1.86,17.78-60.17,71.36-99,33.3-24.16,58.38-31.38,61.54-32.21",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.61,140.29h0l-.52.1.38-.07.14,0",
    style: {
      fill: "#c9c9c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,140.32l-.38.07h0a1.27,1.27,0,0,1,.28,0l.15-.05",
    style: {
      fill: "#3a3a8a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.05,226.12s12.2-23.31,42.91-27.82L231.19,165S192.66,176.68,193.05,226.12Z",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "147.54 495.07 148.5 500.25 148.5 500.26 147.55 495.07 147.54 495.07",
    style: {
      fill: "#87b8aa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.54,495.07c-5.16-1.59-11.74-5.18-15-11.86-3.53-7.17-3.24-17.89,6.7-33.5l1,5.46c7,1.25,16.21,3.19,23.46,7.85h0a23.9,23.9,0,0,1,10.43,13.05c4.71,14.91-15.88,22.28-26.58,19",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.53,483.2h0c3.27,6.68,9.85,10.27,15,11.86h0L146,486.61c-5.43-.32-10.64-1.6-13.47-3.41",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.44,411c-8.11,41.45,4.82,113.25-89.68,113.69a41.83,41.83,0,0,1-22.84-6.37h0a36,36,0,0,1-4.49-3.39c-7-6.16-12-15.12-4.23-26.32,5.29-7.65,16-7.75,27.89-8.82,12.19-1.11,25.65-3.24,35.82-15.61,15.24-18.54,14.26-61.08,14.26-61.08,1.75-18.55,10.48-26,19.68-26.9h0A22.16,22.16,0,0,1,469,377.6c9.36,3.52,17.16,14.39,13.44,33.38",
    style: {
      fill: "#414199"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,312.09c2.29,19-4.16,35.4-14.4,36.64s-20.39-13.17-22.68-32.18,4.15-35.4,14.4-36.64S261.67,293.08,264,312.09Z",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.23,313.57c-4.39,20.17-16.76,34.6-27.63,32.23s-16.11-20.63-11.72-40.8,16.76-34.59,27.62-32.22,16.12,20.63,11.73,40.79",
    style: {
      fill: "#1c1c1c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469,377.6s26.54,22.13-6,101.84c-7.08,17.34-20,27-40.28,32.4a60.67,60.67,0,0,1-1.81,10.09c63.7-13.56,54.34-74.19,61.54-110.95a47.47,47.47,0,0,0,.95-9.17c0-13.38-6.66-21.3-14.39-24.21",
    style: {
      fill: "#2a2a63"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.33,524.4,359.66,422.53c-1.42-7.74-8.84-14-16.58-14H154a11.84,11.84,0,0,0-7.77,2.71h0l-.07.07a11,11,0,0,0-2,2.3l-7.81,8.91,24.9,101.89c1.42,7.73,8.84,14,16.58,14l189.74,4.71,6-6.65c3.7-2.43,5.67-6.92,4.73-12.07",
    style: {
      fill: "#959594"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.89,545.75h-189c-6.45,0-12.7-4.37-15.42-10.32a15.68,15.68,0,0,1-1.16-3.69L153,525l-1.64-9-2.26-12.27-11.36-62v-.07l-1.74-9.5v-.06l-.42-2.26c-1.42-7.73,3.71-14,11.44-14H336.1a17.63,17.63,0,0,1,16.41,13.28l0,.13c.05.19.09.39.13.59l2.19,11.89,12.6,68.82,1.89,10.27,2,10.9c1.42,7.74-3.71,14-11.44,14",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.09,454.2h0a7,7,0,0,0-4.8,1.71l0,0a6,6,0,0,0-2.07,4.53,8.52,8.52,0,0,0,2.24,5.56l.05.05.23.25,1.23,1.25-.75,1.14c-3,4.58-3.81,10.44-2.23,16.52v0l.07.22,0,.1c2.45,8.74,9.49,16.46,18.12,21l3.16-1.78c-8.53-3.74-15.62-11.06-17.87-19.46l0,0h0c-2.11-8.09.65-15.51,7.2-19.32.2-1.28.31-3.69-1.47-5a2.49,2.49,0,0,0-1.44-.5,1.52,1.52,0,0,0-1.11.43,1.41,1.41,0,0,0-.18,2.1l0,0a1.26,1.26,0,0,1-.12,2,1.45,1.45,0,0,1-.72.18,2.2,2.2,0,0,1-1.6-.75c-1.69-1.94-1.68-4.43.05-5.89a4.11,4.11,0,0,1,2.87-1,6.62,6.62,0,0,1,3.92,1.38,7.6,7.6,0,0,1,3.12,5.51,22.47,22.47,0,0,1,7.57-1.25h.05c13.27,0,26.72,9.93,30,22.14a21.59,21.59,0,0,1,.46,2.14l3.12-1.76-.09-.38c-3.75-14-19.14-25.43-34.34-25.43h-.1a28.33,28.33,0,0,0-3.08.17l-1.42.16-1-1.25a12.55,12.55,0,0,0-2.48-2.4,11.18,11.18,0,0,0-6.59-2.32",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.78,485.29a15.24,15.24,0,0,1-2.4-.2c-.46-.07-.59-.15-.66-.42a.85.85,0,0,1,0-.32,2.4,2.4,0,0,1,2.6-2.24h.06a4.75,4.75,0,0,1,3.79,2.11,1.76,1.76,0,0,1,.22.46c0,.17,0,.28-.27.34h0a14.39,14.39,0,0,1-2.74.26h-.58m-14.59.76a3.9,3.9,0,0,1-3.59-2.7,2.06,2.06,0,0,1,2.15-2.7,3.87,3.87,0,0,1,3.58,2.69h0a2.06,2.06,0,0,1-2.14,2.7h0m-4.94-14.91a18.32,18.32,0,0,1-.13,3.93,14.52,14.52,0,0,1-8.22,11.13c2.43,7.62,9.41,14.1,17.46,16.86l8.22-4.65a13.68,13.68,0,0,1-1.59.11,19,19,0,0,1-11.85-4.67,1.4,1.4,0,0,1-.3-2.06h0a1.28,1.28,0,0,1,.88-.31,2.06,2.06,0,0,1,1.37.56h0a14.78,14.78,0,0,0,9.1,3.54,8.5,8.5,0,0,0,7.21-3.54,1.19,1.19,0,0,1,1.08-.56,1.94,1.94,0,0,1,1.05.32,1.64,1.64,0,0,1,.81,2.06l-.18.28,8.81-5a17.46,17.46,0,0,0-.61-3.88,21.59,21.59,0,0,0-2.18-5.23,96.91,96.91,0,0,1-13.11-2c-7.4-1.67-13.38-4-17.83-6.91",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.17,506.56l-11.62,6.57a15.19,15.19,0,0,0,6.69,1.7c3.65,0,7.32-1.65,10.55-5.84l0,0a38.15,38.15,0,0,1-5.64-2.39m6.19-3.5-3,1.72a31.8,31.8,0,0,0,4.63,1.63c.77-.84,1.56-1.61,2.35-2.32a27.66,27.66,0,0,1-3.95-1m15.81-8.93-7.59,4.28a10.59,10.59,0,0,0,7.59-4.28m11.88-6.72L271,489.15a14.15,14.15,0,0,1-2.81,9.33,10.54,10.54,0,0,1,3.15,1.65,16.81,16.81,0,0,0,2.73-12.72m80.79-45.66-77.67,43.9c1.7,6.77.35,12.91-3.23,17.42a15.92,15.92,0,0,1,2.07,8.39,34.6,34.6,0,0,1-2.08,11.07c-3,8.72-5.22,16.44-7.46,23.22H288.2c-1.81-5.93-3.77-12.65-6.35-20.22-.29-.86-.56-1.69-.78-2.5-1.74-6-1.85-10.77-.81-14.31,1.54-5.25,5.6-7.81,10.59-7.81,5.17,0,11.34,2.75,16.71,8.08,3.9,3.87,8.14,5.43,12.14,5.43,8.4,0,15.79-6.84,17.08-13.52,2.46-12.64,9.48-21.13,16.91-21.13,3,0,6.07,1.38,8.93,4.44l-7.78-42.46",
    style: {
      fill: "#c5c5c5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.33,504.78l-3.16,1.78a38.15,38.15,0,0,0,5.64,2.39c.7-.9,1.42-1.75,2.15-2.54a31.8,31.8,0,0,1-4.63-1.63m33.84-19.13-3.12,1.76a16.81,16.81,0,0,1-2.73,12.72,10.43,10.43,0,0,1,2.45,2.66h0l.17.27c3.58-4.51,4.93-10.65,3.23-17.42",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271,489.15l-8.81,5a10.59,10.59,0,0,1-7.59,4.28l-8.22,4.65a27.66,27.66,0,0,0,3.95,1c4.67-4.16,9.69-6.18,14-6.18a12.56,12.56,0,0,1,3.82.57,14.15,14.15,0,0,0,2.81-9.33",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.09,411.24H156.75a1.1,1.1,0,0,0-1.1,1.1v.41a1.1,1.1,0,0,0,1.1,1.1H334.09a1.1,1.1,0,0,0,1.1-1.1v-.41a1.1,1.1,0,0,0-1.1-1.1",
    style: {
      fill: "#adadac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.31,425.77a15.9,15.9,0,0,1,1.2,3.37v.13l0,.07c0,.17.08.35.11.52l.83,4.51-.83-4.51a15.84,15.84,0,0,0-1.35-4.09m0,0v0m-3.18-4.5.17.18h0l-.18-.19m-3.32-2.72h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0,0,0,0,0m0,0h0m0,0,0,0,0,0m-7.25-2.35a16.42,16.42,0,0,1,7.25,2.35,16.42,16.42,0,0,0-7.25-2.35m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m-.09,0h0",
    style: {
      fill: "#adadac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.28,421.41a17,17,0,0,1,4.23,7.73v0a15.9,15.9,0,0,0-1.2-3.37v0a18.11,18.11,0,0,0-3-4.31h0m-11.65-2.53H147.57c-7.45,0-12.49,5.82-11.57,13.17l1.76,9.63c-1.37-7.7,3.74-13.94,11.45-13.94H338.27c7.73,0,15.16,6.28,16.57,14l-1.35-7.38-.83-4.51c0-.17-.07-.35-.11-.52l.65,3.54c-1.42-7.73-8.84-14-16.57-14",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.08,421.2l0,0,0,0m0,0,0,0,0,0m0,0,0,0,0,0m0,0h0m0,0h0m0,0h0m0,0h0",
    style: {
      fill: "#adadac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.1,421.23h0m0,0h0m0,0h0m0,0,0,0,0,0m0,0,0,0,0,0m0,0,0,0,0,0m0,0,0,0,0,0m-3.11-2.5a18.13,18.13,0,0,1,3.11,2.5,18.13,18.13,0,0,0-3.11-2.5m0,0,0,0,0,0m0,0,0,0,0,0m0,0,0,0,0,0m0,0,0,0,0,0m0,0h0m0,0,0,0,0,0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0m-7.25-2.35h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m-.05,0h0m-.05,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m-.05,0h0m0,0h0m0,0h0m0,0h0m0,0h0m0,0h0",
    style: {
      fill: "#adadac"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.93,431.72l.08.4v0l-.07-.37",
    style: {
      fill: "#ededed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.6,429.86l.33,1.86.07.37v0l-.4-2.19",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.73,417.51a10.8,10.8,0,0,0-2.52,2.08,10.52,10.52,0,0,1,2.52-2.07h0",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.52,429.18v.09a.19.19,0,0,0,0,.07l0-.07v-.09m-16.43-13.32H147a12.21,12.21,0,0,0-6.3,1.65h0a12.17,12.17,0,0,1,6.3-1.66H336.1a17.08,17.08,0,0,1,12.1,5.47l.08.08-.17-.18h0l0,0h0l0,0h0l0,0,0,0h0l0,0h0l0,0h0l0,0h0a18.13,18.13,0,0,0-3.11-2.5h0l0,0h0l0,0h0l0,0h0l0,0h-.05l0,0h-.1l0,0h-.05l0,0h0a16.42,16.42,0,0,0-7.25-2.35h-1",
    style: {
      fill: "#bfbfbf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.1,415.86H147a12.17,12.17,0,0,0-6.3,1.66,10.52,10.52,0,0,0-2.52,2.07,11.44,11.44,0,0,0-2.85,7.75,13.76,13.76,0,0,0,.24,2.52h0l.4,2.19c-.92-7.35,4.12-13.17,11.57-13.17H336.63c7.73,0,15.15,6.27,16.57,14l-.65-3.54a.19.19,0,0,1,0-.07v-.13a17,17,0,0,0-4.23-7.73l-.08-.08a17.08,17.08,0,0,0-12.1-5.47",
    style: {
      fill: "#e3e3e3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.93,522.53c-4.56,13.37-7.42,24.41-11.14,33.25-7.53,17.94-18.6,26.82-54.65,27.45-33.91.6-49.92-8.44-59.18-21.06a57.77,57.77,0,0,1-5.91-10.09c-2.2-4.69-4-9.62-5.72-14.54-8.3-23.31-6.41-38.91,3.33-38.44s10.73,5.49,19.51,13.51c12.58,11.47,13.7,3.7,19.92-12.22,10-25.68,29-15.08,36.47.51,4.33,9.05,19,21.38,29.23,8.09,9.67-12.55,22.79-14.18,28-6.2h0c2.67,4.1,3.23,10.74.16,19.73",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.77,502.8c.36,6.08-8.65,46-26.06,55.9-6,3.39-26.6,10.6-53.57,10.6A144.47,144.47,0,0,1,149,562.17c9,12.22,24.27,21.09,56,21.09l3.16,0c36.05-.63,47.12-9.51,54.65-27.45,3.72-8.84,6.58-19.88,11.14-33.25A34.6,34.6,0,0,0,276,511.46a15.65,15.65,0,0,0-2.24-8.66",
    style: {
      fill: "#bc7d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416,537.54a146.67,146.67,0,0,1-6.31,15.76c-8.36,17-23,30.67-64.51,29.93-36.53-.64-46.29-8.37-53.11-25.92q-1-2.47-1.87-5.22c-2.46-7.35-4.82-16.16-8.37-26.56-.29-.86-.56-1.69-.78-2.5-1.74-6-1.85-10.77-.81-14.31,3.14-10.71,16.75-10.19,27.3.27,12.1,12,27.31,1.77,29.22-8.09C341,479,359,469.53,369.07,495.23c6.22,15.91,11.53,28.85,24.1,17.38,8.78-8,13.11-10.75,22.85-11.24a7.07,7.07,0,0,1,3.38.58h0c5.8,2.81,3.74,15.49-3.4,35.59",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.42,502h0c5.8,9.58-6.51,47.09-38.95,55.36-13.84,3.54-29.47,4.85-43.9,4.85-19.36,0-36.58-2.36-44.46-4.85,6.82,17.55,16.58,25.28,53.11,25.92l3.16,0c39.06,0,53.2-13.41,61.35-30A146.67,146.67,0,0,0,416,537.54c4.31-12.13,6.77-21.56,6.77-27.74,0-4.07-1.07-6.74-3.37-7.85",
    style: {
      fill: "#bc7d33"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.87,376.18h0c-9.2.93-17.93,8.35-19.68,26.9,0,0,0,.55,0,1.54,0,7.79-.76,43.1-14.27,59.54a38.9,38.9,0,0,1-6.81,6.53c-9,6.69-19.38,8.2-29,9.08,1.87.26,3.86.48,6,.62s4.3.22,6.33.22c52.94,0,48.52-49.69,48.08-72.81-.45-24,9.4-31.62,9.4-31.62",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.26,138.79V255.48L452.39,266l-.26-.58c.16-25.44.53-92.6-.07-114.49-.75-27.21-113.87-32.84-165.19-32.84-22.06,0-41.74,1.15-57,3.61-16.77,2.68-28.21,6.95-31.67,13,.41-.94,6.33-13.47,32-20.93a128.84,128.84,0,0,1,19.35-3.93c12.75-1.66,30.9-2.09,45.86-2.09C470.85,107.8,488.26,131.9,488.26,138.79Z",
    style: {
      fill: "#ffc7d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.25,348.78c1.37,11.38-15.9,22.83-38.57,25.56s-42.16-4.29-43.54-15.67,15.9-22.83,38.57-25.56S390.87,337.39,392.25,348.78Z",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.91,357.41c-1.05,9.86-17.4,16.21-36.51,14.17S192.65,359.9,193.7,350s17.39-16.21,36.51-14.17,33.75,11.68,32.7,21.54",
    style: {
      fill: "#ffef2c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.55,348.7s2.8,42.39-43.08,42.39c-12.47,0-19.62-16.06-41.05-47.85,0,0,31.5-3.45,43.45,1.48Z",
    style: {
      fill: "#dd903c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.58,319.66c18,7.67,23.22,20.09,25,29,0,0-5.09,26.43-27.32,19.79S267.12,342.87,227,347.62c10.1-15.57,47.69-40.69,77.61-28",
    style: {
      fill: "#ffaa45"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.79,320.52a51.43,51.43,0,0,0-18.16,3.22.8.8,0,0,0,.29,1.55H268a95.59,95.59,0,0,1,12.35-.81c14.38,0,24.84,3.4,29.89,5.85a.77.77,0,0,0,.35.08.81.81,0,0,0,.7-1.19l-.92-1.74a4.56,4.56,0,0,0-2.11-2,53.59,53.59,0,0,0-22.51-4.94",
    style: {
      fill: "#ffcd60"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.48,260.37c-16,19.35-11.82,68-3.15,95.68s48.09,25.69,59.91,11.11,12.81-102.11-7.82-111.75c-21.86-10.21-40.88-4.75-48.94,5",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.62,274.7a1.07,1.07,0,0,0-1.08.92c-2.81,16.5-5.93,49,4.11,84a1.07,1.07,0,0,0,1.07.82,1.13,1.13,0,0,0,1.16-1.24c-1.51-17.23-4.25-52.88-4.14-83.39a1.08,1.08,0,0,0-1.12-1.11",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.58,293.52c-1.36,0-2.59,2.16-3.53,5.72a81.05,81.05,0,0,0,0,33.88c.94,3.56,2.17,5.72,3.53,5.72,1.86,0,3.5-4,4.44-10.17a89.08,89.08,0,0,0,0-25c-.94-6.13-2.58-10.17-4.44-10.17",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M502.58,316.17a18.66,18.66,0,0,1-4.56,12.5,13.41,13.41,0,0,1-8,4.45,81.05,81.05,0,0,1,0-33.88,13.41,13.41,0,0,1,8,4.45A18.63,18.63,0,0,1,502.58,316.17Z",
    style: {
      fill: "#ffc7d0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.32,374.54l-.3,3.65-.25,3.18A243.15,243.15,0,0,1,168,377.85l-1.84-.38c-11.59-2.45-19.5-5.39-24-9h0l-.15-.13c-3.05-2.49-4.48-5.29-4.35-8.45.45-10.63,16-22.16,26.5-28.74q.22,3.85.5,7.84a111.75,111.75,0,0,0-9.55,7.06c-6,4.95-10.45,10.08-10.61,14.12v0c0,.72.8,5.78,22.83,10.48l.25.06a238.39,238.39,0,0,0,25.79,3.77",
    style: {
      fill: "#ec6b7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.11,331.17h0c-10.51,6.58-26.05,18.11-26.5,28.74v.4c0,3,1.43,5.67,4.35,8.05a10.43,10.43,0,0,1-3.27-8.17c.19-4.86,8.61-11.31,16.37-14.12a111.75,111.75,0,0,1,9.55-7.06q-.27-4-.5-7.84",
    style: {
      fill: "#994550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.38,374.13l-.55,6.82-.25,3.18a9,9,0,0,1-11,8l-18.67-4.34a9,9,0,0,1-6.79-7.09,9.14,9.14,0,0,1-.09-2.77l.12-1c.12-1,.27-2,.42-3a4.88,4.88,0,0,1,.08-.51c.07-.51.14-1,.23-1.53a9,9,0,0,1,8.86-7.5h18.66a9,9,0,0,1,8.95,9.69",
    style: {
      fill: "#d1d1d1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.8,372.63c-.05.28-.09.56-.13.84h0c0-.28.07-.56.12-.84",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,373.47h0a4.88,4.88,0,0,0-.08.51h0a4.88,4.88,0,0,1,.08-.51h0",
    style: {
      fill: "#f495ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.43,364.44H192.77a9,9,0,0,0-8.86,7.5h0c0,.23-.08.46-.11.69s-.08.56-.12.84h0a4.88,4.88,0,0,0-.08.51c.31-.28,5.51-4.53,15.32-4.53.89,0,1.82,0,2.78.11,4,.31,7.84.42,11.25.42,2.55,0,4.84-.06,6.71-.14a9,9,0,0,0-8.23-5.4",
    style: {
      fill: "#e4e4e4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.15,380.74a9,9,0,0,0,6.79,7.09l18.67,4.34a9,9,0,0,0,11-8l.25-3.18c-1.9,1.56-3.78,4.09-10.64,4.09a38.22,38.22,0,0,1-5.14-.39,205.34,205.34,0,0,1-20.9-3.91",
    style: {
      fill: "#878787"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146,362.7c1.36,1.26,3.93,2.88,8.8,4.61-4.87-1.73-7.44-3.35-8.8-4.61",
    style: {
      fill: "#dfdfdf"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.53,370.77h0c3.4.72,6.82,1.32,10,1.82-3.18-.5-6.6-1.1-10-1.82h0",
    style: {
      fill: "#5b5bc2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.47,360.41a7.27,7.27,0,0,0,4,6.19c10.16,5.86,21.54,8,34.67,10.4.12-1,.27-2,.42-3h0c0-.17,0-.34.07-.51-1.88-.24-3.95-.54-6.14-.88-3.18-.5-6.6-1.1-10-1.82h0a102.55,102.55,0,0,1-12.78-3.46c-4.87-1.73-7.44-3.35-8.8-4.61a4.13,4.13,0,0,1-1.48-2.29",
    style: {
      fill: "#f495ad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.67,373.47c0,.17,0,.34-.07.51a4.88,4.88,0,0,1,.08-.51h0",
    style: {
      fill: "#f9c0ce"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.11,368.5l-.15-.14Z",
    style: {
      fill: "#cecece"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.61,398.28,122.79,311.5a21.61,21.61,0,0,0-21.31-18H42.07a21.62,21.62,0,0,0-21.23,25.77l7.27,37.21A21.64,21.64,0,0,0,49.34,374h65.72Z",
    style: {
      fill: "#f7de8f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M566.38,135.94a51.34,51.34,0,0,0-31.35,92c-2.64,8.06-8.27,18.73-20,22,0,0,26.77-.36,41.65-12.23a51.34,51.34,0,1,0,9.69-101.76Z",
    style: {
      fill: "#b6e7f2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    width: 637.99,
    height: 743.31,
    style: {
      fill: "none"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuidoWaiting);
export default __webpack_public_path__ + "static/media/guido_waiting.4f479c490de7afa22f9a436e3fdb50e6.svg";
export { ForwardRef as ReactComponent };